// Service pour l'API DALL-E (génération d'images)
const DALL_E_API_KEY = process.env.REACT_APP_OPENAI_API_KEY; // Même clé que Claude
const DALL_E_API_URL = 'https://api.openai.com/v1/images/generations';

/**
 * Génère une image avec DALL-E
 * @param {string} prompt - Description de l'image à générer
 * @param {string} size - Taille de l'image (256x256, 512x512, 1024x1024)
 * @param {string} quality - Qualité (standard, hd)
 * @param {string} style - Style (vivid, natural)
 * @returns {Promise<Object>} - URL de l'image générée
 */
export const generateImageWithDalle = async (prompt, size = "1024x1024", quality = "standard", style = "vivid") => {
    if (!DALL_E_API_KEY) {
        throw new Error('Clé API OpenAI manquante. Ajoutez REACT_APP_OPENAI_API_KEY dans votre .env');
    }

    try {
        console.log('🎨 Génération d\'image DALL-E:', prompt);
        
        const doRequest = async () => {
            const response = await fetch(DALL_E_API_URL, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${DALL_E_API_KEY}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    model: "dall-e-3",
                    prompt: prompt,
                    n: 1,
                    size: size,
                    quality: quality,
                    style: style
                })
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                const msg = errorData.error?.message || `HTTP ${response.status}`;
                // 429/503 ~ surcharge / rate limit
                if ([429, 503].includes(response.status)) {
                    throw new Error(`TEMP_DALLE: ${msg}`);
                }
                throw new Error(`Erreur DALL-E: ${msg}`);
            }
            return response.json();
        };

        // Retry exponentiel simple 3 fois si TEMP_DALLE
        const delays = [600, 1400];
        let lastErr = null;
        for (let attempt = 0; attempt < 3; attempt++) {
            try {
                const data = await doRequest();
                console.log('✅ Image générée avec succès:', data);
                return {
                    url: data.data[0].url,
                    revisedPrompt: data.data[0].revised_prompt,
                    created: data.created
                };
            } catch (e) {
                lastErr = e;
                if (String(e.message || '').startsWith('TEMP_DALLE') && attempt < 2) {
                    await new Promise(r => setTimeout(r, delays[attempt]));
                    continue;
                }
                break;
            }
        }
        throw lastErr || new Error('Erreur DALL-E inconnue');
    } catch (error) {
        console.error('❌ Erreur génération image:', error);
        throw error;
    }
};

/**
 * Génère une image avec DALL-E 2 (moins cher, plus rapide)
 * @param {string} prompt - Description de l'image à générer
 * @param {string} size - Taille de l'image (256x256, 512x512, 1024x1024)
 * @returns {Promise<Object>} - URL de l'image générée
 */
export const generateImageWithDalle2 = async (prompt, size = "1024x1024") => {
    if (!DALL_E_API_KEY) {
        throw new Error('Clé API OpenAI manquante. Ajoutez REACT_APP_OPENAI_API_KEY dans votre .env');
    }

    try {
        console.log('🎨 Génération d\'image DALL-E 2:', prompt);
        
        const response = await fetch(DALL_E_API_URL, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${DALL_E_API_KEY}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                model: "dall-e-2",
                prompt: prompt,
                n: 1,
                size: size
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Erreur DALL-E 2: ${errorData.error?.message || 'Erreur inconnue'}`);
        }

        const data = await response.json();
        console.log('✅ Image DALL-E 2 générée avec succès:', data);
        
        return {
            url: data.data[0].url,
            created: data.created
        };
    } catch (error) {
        console.error('❌ Erreur génération image DALL-E 2:', error);
        throw error;
    }
};

/**
 * Vérifie si l'API DALL-E est disponible
 * @returns {boolean}
 */
export const isDalleAvailable = () => {
    return !!DALL_E_API_KEY;
}; 